import ArrowBackIosIcon from "@material-ui/icons/ArrowBackIos";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
} from "@mui/material";
import { Button } from "@material-ui/core";
import React, { useState } from "react";
import { useEffect } from "react";
import { useHistory, useLocation } from "react-router-dom";
import http from "../services/reportsPath";
import { marketingpath, getDate } from "../utils/varialbles";
import SearchBar from "material-ui-search-bar";
import toast from "react-hot-toast";

function Marketparent() {
  const [prospect, setProspect] = useState([
    {
      headerName: "Assigned executive empfname",
      id: "assigned_executive__empfname",
      show: true,
      minWidth: 100,
    },
    {
      headerName: "Campaign",
      id: "cust__campaign",
      show: true,
      minWidth: 150,
    },
    {
      headerName: "Create Date",
      id: "cust__createddt",
      show: true,
      minWidth: 150,
      type: "date",
    },
    {
      headerName: "City",
      id: "cust__custcity",
      show: true,
      minWidth: 150,
    },
    {
      headerName: "Country",
      id: "cust__custcountry__locname",
      show: true,
      minWidth: 150,
    },
    {
      headerName: "Cust State",
      id: "cust__custstate",
      show: true,
      minWidth: 150,
    },
    {
      headerName: "Cust ID",
      id: "cust__id",
      show: true,
      minWidth: 150,
    },
    {
      headerName: "Last login",
      id: "cust__last_login",
      show: true,
      minWidth: 150,
      type: "date",
    },
    {
      headerName: "Signup from",
      id: "cust__signupfrom",
      show: true,
      minWidth: 150,
    },
    {
      headerName: "Cust UserID",
      id: "cust__userID",
      show: true,
      minWidth: 150,
    },
    {
      headerName: "Downloaded",
      id: "downloaded",
      show: true,
      minWidth: 150,
    },
    {
      headerName: "ID",
      id: "id",
      show: true,
      minWidth: 150,
    },
    {
      headerName: "Lead Source",
      id: "lead_source",
      show: true,
      minWidth: 150,
    },
    {
      headerName: "OS",
      id: "os",
      show: true,
      minWidth: 150,
    },
  ]);

  const [investor, setInvestor] = useState([
    {
      headerName: "AppOS",
      id: "AppOS",
      show: true,
      minWidth: 150,
    },

    {
      headerName: "App Downloaded",
      id: "App_Downloaded",
      show: true,
      minWidth: 150,
    },
    {
      headerName: "Country",
      id: "Country",
      show: true,
      minWidth: 150,
    },
    {
      headerName: "User ID",
      id: "UserID",
      show: true,
      minWidth: 150,
    },
    {
      headerName: "Days Remaining",
      id: "days_remaining",
      show: true,
      minWidth: 150,
    },
    {
      headerName: "Execute",
      id: "exec",
      show: true,
      minWidth: 150,
    },
    {
      headerName: "ID",
      id: "id",
      show: true,
      minWidth: 150,
    },
    {
      headerName: "Last Login",
      id: "last_log",
      show: true,
      minWidth: 150,
      type: "date",
    },
    {
      headerName: "Lead Source",
      id: "leadsource",
      show: true,
      minWidth: 150,
    },
    {
      headerName: "Plan",
      id: "plan",
      show: true,
      minWidth: 150,
    },
    {
      headerName: "Remaining Investment Requests",
      id: "remaininginvreqs",
      show: true,
      minWidth: 150,
    },
    {
      headerName: "Remaining Investment Review Request",
      id: "remaininginvreviewreqs",
      show: true,
      minWidth: 150,
    },
  ]);

  const marketparent = [
    {
      id: 0,
      apiname: "marketing_prospect",
      columnName: prospect,
    },
    {
      id: 1,
      apiname: "marketing_investment",
      columnName: investor,
    },
  ];

  const history = useHistory();

  const location = useLocation();

  const myparam = location;
  // console.log(myparam);

  const [cols, setCols] = useState([]);
  // console.log(cols);

  const [rows, setRows] = useState([]);

  const [totalRowCount, setTotalRowCount] = useState("");
  // console.log(totalRowCount);

  const [rowsPerPage, setRowsPerPage] = useState(10);
  // console.log(rowsPerPage);

  const [page, setPage] = useState(0);

  const [apiname, setApiname] = useState("");

  const [searched, setSearched] = useState("");

  const handleChangeRowsPerPage = (e) => {
    setRowsPerPage(e.target.value);
    // setPage(0);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  let uniqueApiNames = {};

  // let url="" ;

  // if(searched){
  //   url=`${baseUrl}?page=${page + 1}&rowsPerPage=${rowsPerPage}&search=${searched}`;
  // }
  // else if(!searched){
  //   url=`${baseUrl}?page=${page + 1}&rowsPerPage=${rowsPerPage}`
  // }

  const getPaginationURL = (url, newQuery) => {
    const query = newQuery === "" ? newQuery : searched;
    if (query) {
      return `${url}?page=${
        page + 1
      }&rowsPerPage=${rowsPerPage}&emp_id=${query}`;
    } else if (!query) {
      return `${url}?page=${page + 1}&rowsPerPage=${rowsPerPage}`;
    }
  };

  useEffect(() => {
    const finalCols = marketparent.filter((ele) => {
      return ele.id === myparam.id;
    });

    setCols(finalCols[0].columnName);

    uniqueApiNames = finalCols[0];

    getData();
  }, [rowsPerPage, page, apiname]);

  const getData = (newQuery) => {
    const baseURL = uniqueApiNames.apiname;
    http
      .get(getPaginationURL(baseURL, newQuery))
      .then((res) => {
        const tempData = res.data.data;
        setRows(tempData);
        setTotalRowCount(res.data.totalRowCount);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const goToMarketCards = (e) => {
    e.preventDefault();
    history.push({
      pathname: marketingpath,
    });
  };

  const requestSearch = (searchVal) => {
    setSearched(searchVal);
  };

  const cancelSearch = () => {
    setSearched("");
  };

  return (
    <div>
      <Button
        variant="outlined"
        color="default"
        startIcon={<ArrowBackIosIcon />}
        onClick={goToMarketCards}
      >
        Back
      </Button>

      <SearchBar
        value={searched}
        onChange={(searchVal) => requestSearch(searchVal)}
        onCancelSearch={() => cancelSearch()}
        style={{ width: "200px", marginTop: "20px" }}
      />

      <TablePagination
        component="div"
        rowsPerPageOptions={[10, 50, 100, 500]}
        count={totalRowCount}
        rowsPerPage={rowsPerPage}
        page={page}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
      />

      <TableContainer>
        <Table>
          <TableHead>
            <TableRow>
              {cols.map((item) => {
                return <TableCell>{item.headerName}</TableCell>;
              })}
            </TableRow>
          </TableHead>

          <TableBody>
            {rows.length !== 0 ? (
              rows.map((row, index) => {
                return (
                  <TableRow>
                    {cols.map((column, index) => {
                      const value = row[column.id];
                      // console.log(row);
                      return (
                        <TableCell>
                          {column.type === "date"
                            ? getDate(value)
                            : column.headerName === "Downloaded" ||
                              column.headerName === "App Downloaded"
                            ? value
                              ? "True"
                              : "N/A"
                            : value
                            ? value
                            : "N/A"}
                        </TableCell>
                      );
                    })}
                  </TableRow>
                );
              })
            ) : (
              <TableRow>
                <TableCell
                  colspan="14"
                  style={{
                    "text-align": "center",
                    margin: "10px 0px",
                    fontSize: 25,
                  }}
                >
                  No Data Available...
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>
    </div>
  );
}

export default Marketparent;
